import studentRequest from 'utils/studentRequest'
import instRequest from 'utils/instRequest'
import ErrorMessage from 'utils/ErrorMessage'
import { readDownloadErrorMessage } from 'utils/downloadFile'

export const GET_TABLE = 'GET_TABLE'
export const GET_BATCH_HISTORY = 'GET_BATCH_HISTORY'

export const getPlacementData =
  (
    instituteCampusId,
    groupBy,
    educationType,
    domainId,
    degreeId,
    folderSearch
  ) =>
  async (dispatch, getState) => {
    try {
      let url = `/institutes/instituteCampus/${instituteCampusId}/courses/overView?groupBy=${groupBy}`

      if (educationType) {
        url += `&educationType=${educationType}`
      }
      if (domainId) {
        url += `&domainId=${domainId}`
      }
      if (degreeId) {
        url += `&degreeId=${degreeId}`
      }
      if (folderSearch) {
        url += `&search=${folderSearch}`
      }
      const result = await instRequest.get(url)
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getTableData =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    try {
      let url = `/students/institutes/${instituteCampusId}/batch/list`
      const result = await studentRequest.post(url, payload)
      dispatch({ type: GET_TABLE, payload: result?.data })
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getPlacementStudent =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    try {
      const result = await studentRequest.post(
        `/students/institutes/${instituteCampusId}/batch/list`,
        payload
      )
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getPreviewData = student_Id => async (dispatch, getState) => {
  try {
    const res = await studentRequest.get(`/students/${student_Id}`)
    return res?.data?.data
  } catch (error) {}
}

export const resumeBulkDownload = (payload) => async () => {
  try {
    const options = {}

    if (payload?.studentIds[0]?.length <= 5) {
      options.responseType = 'blob'
    }
    const response = await studentRequest.post(
      `/students/resume/bulkdownload`,
      payload,
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error }
  }
}

// See modules/Drives/actions.js — `corporate: true` makes student-node serve the
// candidate's own uploaded CV for the role instead of a generated system resume.
export const resumeBulkDownloadJobRoles = (payload) => async () => {
  try {
    const options = {}

    if (payload?.studentIds[0]?.length <= 5) {
      options.responseType = 'blob'
    }
    const response = await studentRequest.post(
      `/students/resume/bulkdownload/jobRoles`,
      { ...payload, corporate: true },
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error, errorMessage: await readDownloadErrorMessage(error) }
  }
}
